import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch, connect } from 'react-redux';

import Intro from './Intro';
import CreateYourChannels from './CreateYourChannels';
import Summary from './Summary';
import Section from '../../components/Section';
import * as AppRoute from '../../utils/appRoutes';
import { prepareComponents } from '../../utils/helpers';
import { select } from '../../rematcher/store';

const components = [Intro, CreateYourChannels, Summary];

function Channel({
  locales,
  locales: {
    channel: { name, menu, sectionName },
  },
  progress,
}) {
  const {
    channel: { fetchChannels },
    bmc: { fetchCurrentBmc, updateBmc },
  } = useDispatch();

  const {
    bmc: { current: currentBmc },
  } = useSelector((state) => state);

  const { bmcId } = useParams();
  const preparedComponents = prepareComponents(
    components,
    bmcId,
    menu,
    AppRoute.channel,
  );

  const getData = () => {
    fetchCurrentBmc(bmcId);
    fetchChannels(bmcId);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (currentBmc.id)
      updateBmc({
        id: currentBmc.id,
        name: 'channels_progress',
        value: parseInt(progress),
      });
  }, [progress]);

  return (
    <Section
      components={preparedComponents}
      sectionName={sectionName}
      sectionLocaleName={name}
      menuItems={menu}
      progress={progress}
      locales={locales}
      finalDestination={`${AppRoute.bmc(bmcId)}`}
      onComponentChange={getData}
    />
  );
}

const mapState = select((models) => ({
  progress: models.progress.channelProgress,
}));

export default connect(mapState, null)(Channel);
